import { useEffect, useState } from "react";
import { EntityReactionType } from "@shared/Types/Reactions/ReactionTypes.types";
import { ReactionActorConstructor } from "../ReactionActors";
import { UseReactionsReturn } from "./useReactions.types";
import { useReactOnEntity } from "./useReactOnEntity";
import { ReactionAction } from "../Reactions.types";

export const useReactions = (
    entityId: string | number,
    entityReactions: EntityReactionType[],
    reactionActorConstructor: ReactionActorConstructor,
): UseReactionsReturn => {
    const [entityReactionsState, setEntityReactionsState] =
        useState(entityReactions);
    const { reactOnEntityById } = useReactOnEntity(
        reactionActorConstructor,
        setEntityReactionsState,
    );

    useEffect(() => {
        setEntityReactionsState(entityReactions);
    }, [entityReactions]);

    const reactOnEntity = async (
        reactionName: string,
        reactionAction: ReactionAction,
    ) => {
        return reactOnEntityById(entityId, reactionName, reactionAction);
    };

    return {
        entityReactionsState,
        reactOnEntity,
    };
};
